<mat-toolbar class="header-color">
    <mat-toolbar-row>
      <span> Email </span>
      <span class="example-spacer"></span>
      <button class="btn button" (click)="openMailCopyDialog()"  mat-fab extended>
        <mat-icon>add</mat-icon>
        Add Mail
      </button>
      <!-- <button class="btn button" (click)="import()">
        Import
      </button> -->
    </mat-toolbar-row>
    <ng-template #productLabel>
      <mat-toolbar-row>
        <span> Products </span>
      </mat-toolbar-row>
    </ng-template>
  
  </mat-toolbar>

<app-table-standard-layout [dataSource$]="dataSource$" [title]="'Emails'" [rowActionButtons]="rowActionButtons"
  [columnSettings]="columnSettings"></app-table-standard-layout>